export default __webpack_public_path__ + "static/media/bg24.2e6b2850.jpg";